import ProjectModel        from '@models/map/ProjectModel';
import ThemeModel          from '@models/map/ThemeModel';
import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import MapServiceModel     from '@/models/MapServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import Blamable            from '@/models/traits/Blamable';
import WithProjectPagePath from '@/models/traits/WithProjectPagePath';
import Bullet              from '@widesk-ui/components/Bullet';

@model.urnResource('place_type')
@doc.path('/place_types/{?id}')
export default class PlaceTypeModel extends Blamable(TimestampAble(WithProjectPagePath(MapServiceModel))) {
	private declare _tsFilters: {
		'createdAt': string;
		'exists[places]': boolean;
		'exists[placeTypeFields]': boolean;
		'placeTypeFields': id;
		'places': id;
		'project': id;
		'theme': id;
		'updatedAt': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'label': string;
		'updatedAt': string;
	};	

	@doc.string declare label: string;
	@doc.string declare reference: string;
	@doc.string declare color: string;
	@doc.model(ProjectModel) declare project: ProjectModel;
	@doc.model(ThemeModel) declare theme: ThemeModel;

	public get customTag() {
		return Bullet;
	}
}
